import axios from "../configRequest";
import { I_AXIOS } from "../configRequest.model";

interface Payload {
    token: string;
    deviceId: string;
}

interface Data {
    success: boolean;
    autopayStatus: {
        status: string;
    };
}

async function apiAutopayCheckStatus(payload: Payload) {
    const fetchData = await axios.get<Data>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/site/quest/autopay/${payload.deviceId}?token=${payload.token}`,
    );
    return fetchData.data;
}

export default apiAutopayCheckStatus;
